import { render, staticRenderFns } from "./EmployeePortrait.vue?vue&type=template&id=534d0dcd&scoped=true&"
import script from "./EmployeePortrait.vue?vue&type=script&lang=ts&"
export * from "./EmployeePortrait.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeePortrait.vue?vue&type=style&index=0&id=534d0dcd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534d0dcd",
  null
  
)

export default component.exports